export const ndfl3StepsMapping = [
  {
    title: 'Данные',
    name: 'initialData', // userData
  },
  {
    title: 'Доходы',
    name: 'sheetA', // incomes
  },
  {
    title: 'Выбор вычетов',
    name: 'deductionSelector', // selectDeductions
  },
  {
    title: 'Вычеты',
    name: 'deductions', // deductions
  },
  {
    title: 'Просмотр',
    name: 'submit',
  },
];

export const ndfl3StepsMapping2020 = [
  {
    title: 'Данные',
    name: 'initialData', // userData
  },
  {
    title: 'Доходы',
    name: 'sheetA', // incomes
  },
  {
    title: 'Выбор вычетов',
    name: 'deductionSelector', // selectDeductions
  },
  {
    title: 'Вычеты',
    name: 'deductions', // deductions
  },
  {
    title: 'Распорядиться переплатой',
    name: 'overpayments', // overpayments
  },
  {
    title: 'Просмотр',
    name: 'submit',
  },
];

export const getStepsMapByYear = (reportYear) =>
  reportYear >= 2020 ? ndfl3StepsMapping2020 : ndfl3StepsMapping;

export const ndfl3BreadCrumbsMapping = {
  initialData: 'Титульный лист',
  outRF: 'Лист Б',
  inRF: 'Лист А',
  investmentDeduction: 'Лист Е2',
  lossesTransferDeduction: 'Лист З',
  propertyDeduction: 'Лист Д1',
  socialDeduction: 'Лист Е1',
};

export const ndfl3StepCreateHandler = (props, { index, stepComplete }) => () => {
  stepComplete &&
    props.activeStepIndex !== props.stepsMap.length &&
    props.goToStep &&
    props.goToStep(index);
};
